module.exports = __webpack_public_path__ + "static/media/PATS_2-1363w.a5d60f21.webp";